var klevu_uc = {
  showProductData: function (product) {
    var toReturn = '',
      priceWithCurrency = '',
      appendCurrencyAtLast = false,
      salepriceClass = 'klevu-saleprice',
      additionalParams = '',
      priceFormatter,
      priceToSet,
      showToLabel = false,
      trackingParams = "",
      addToCartQty = 1;

    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }
    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }

    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\'' +
      '}' +
      '}';

    toReturn += '<li>';
    toReturn += '<a href="' + product.productUrl.replace(/"/g, "%22") +
      '" class="klevu-result-box" ';
    if (klevu_commons.isMobileDevice()) {
      toReturn += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');"  >';
    } else {
      toReturn += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' +
        additionalParams + ' >';
    }
    toReturn += '<div class="klevu-img-wrap"><img src="' +
      product.productImage + '" onerror="this.onerror=null;this.src=\'' +
      klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/></div>';
    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '0' && product.discount != '0.0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        toReturn += '<div class="klevu-discount-badge">' +
          klevu_uiLabels.discountBadgeText + ' ' + Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        toReturn += '<div class="klevu-discount-badge">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';

      }
    }
    toReturn += '<div class="klevu-name-desc">' +
      '<div class="klevu-name">' + product.productName + '</div>' +
      '<div class="klevu-desc">' + product.productDescription + '</div>';
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      toReturn += '<div class="klevu-stars-small">' +
        '<div class="klevu-rating" style="width:' + starWidth +
        '%;"></div></div>';
    }
    toReturn += '</div>';

    toReturn += '<div class="klevu-price">';
    if (klevu_showPrices) {
      if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
        toReturn += klevu_commons.showOriginalAndSalePrices('BASIC', product,
          salepriceClass, 'klevu-saleprice klevu-special-price');
      } else {
        toReturn += klevu_commons.showProductPrices('BASIC', product,
          salepriceClass, 'klevu-saleprice klevu-special-price');
      }
    }
    if (klevu_userOptions.vatCaption.trim().length > 0) {
      toReturn += '<div class="klevu-vat-caption">(' +
        klevu_userOptions.vatCaption + ')</div>';
    }
    if (product.totalProductVariants && product.totalProductVariants != '0') {
      toReturn += '<div class="klevu-variants">+' +
        product.totalProductVariants + ' ' +
        klevu_uiLabels.variants + '</div>';
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if ((product.inStock) && product.inStock === 'no') {
        toReturn += '<div class="klevu-out-of-stock">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }
    toReturn += '</div>';
    toReturn += '<div class="klevu-clear-left"></div>';
    toReturn += '</a>';

    if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
      if (!product.totalProductVariants || product.totalProductVariants == '0') {
        if (klevu_userOptions.fullpageLayoutEnabled) {
          toReturn += '<a href="javascript:klevu_layout.sendProductToCart(\'' +
            escape(product.productCode) +
            '\', \'' + escape(product.productUrl) +
            '\');" class="klevu-addtocart">' +
            klevu_userOptions.addToCartButton + '</a>';
        } else {
          if (product.defaultQty) {
            addToCartQty = +(product.defaultQty);
          }
          toReturn += '<div class="klevu-addtocart">' +
            '<input type="text" name="klevu-qty" id="klevu-qty-' +
            escape(product.productCode) + '" placeholder="' +
            klevu_uiLabels.addToCartPlaceholder + '" value="' + addToCartQty + '"/>' +
            '<a href="javascript:klevu_layout.sendProductToCart(\'' +
            escape(product.productCode) + '\', \'' +
            escape(product.productUrl) + '\', \'klevu-qty-' +
            escape(product.productCode) + '\');" ' +
            'class="klevu-addtocart-btn">' + klevu_userOptions.addToCartButton + '</a>' +
            '</div>';
        }
      } else {
        if (klevu_userOptions.fullpageLayoutEnabled) {
          toReturn += '<a href="' + product.productUrl.replace(/"/g, "%22") +
            '" class="klevu-addtocart">' +
            klevu_userOptions.addToCartButton + '</a>';
        } else {
          toReturn += '<div class="klevu-addtocart">' +
            '<a href="' + product.productUrl.replace(/"/g, "%22") +
            '" class="klevu-addtocart-btn">' + klevu_userOptions.addToCartButton + '</a>' +
            '</div>';
        }
      }
      toReturn += '<div class="klevu-clearboth-listview"></div>';
    }
    toReturn += '</li>';
    return toReturn;
  },

  showLandingPageData: function (product) {
    var toReturn = '',
      toAppendwithSalePrice = '',
      priceWithCurrency = '',
      appendCurrencyAtLast = false,
      salepriceClass = 'kuSalePrice',
      priceFormatter, priceToSet,
      showToLabel = false,
      additionalParams = '',
      keywords = document.getElementById('searchedKeyword').value,
      trackingParams = "",
      addToCartQty = 1,
      freeShipping,
      freeShippingOver35,
      prodPrice, prodSalePrice, prodOldPrice;

    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }

    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }
    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\'' +
      '},' +
      'apiKey: null,' +
      'keywordsLP: \'' + escape(keywords) + '\'' +
      '}';
    // code for the result block

    freeShipping = typeof product.discounts !== "undefined" && product.discounts.toLowerCase() === "free shipping" ? true : false;
    freeShippingOver35 = typeof product.discounts !== "undefined" && product.discounts.toLowerCase() === "freeover35" ? true : false;
    soldOut = typeof product.stock !== "undefined" && product.stock.toLowerCase() === "out of stock" ? true : false;

    toReturn += '<li>';

    if (freeShipping) {
      toReturn += '<div class="productgrid--item"><div class="free-shipping"><a href="javascript:void(0);" onclick="openFreeShip()"><div class="orange-band-container"><span class="icon-font"></span><span class="ribbon-text">Free Shipping</span></div><img class="ribbon-end" src="https://cdn.shopify.com/s/files/1/2236/0921/t/9/assets/lifeandhome-cat-freeship_back.png"></a></div></div>';
    }

    if (freeShippingOver35) {
      toReturn += '<div class="product-offers-container productgrid--item"><div class="free-ship-div-thirty-five"><a href="javascript:void(0);" onclick="openFreeShip()"><div class="orange-band-container"><span class="icon-font"></span><span class="ribbon-text">Free shipping over $35</span></div><img class="ribbon-end" src="https://cdn.shopify.com/s/files/1/2236/0921/t/9/assets/lifeandhome-cat-freeship_back.png"></a></div></div>';
    }

    toReturn += '<div class="klevuImgWrap"><a href="' + product.productUrl.replace(/"/g, "%22") +
      '" target="_blank" ';
    if (klevu_commons.isMobileDevice()) {
      toReturn += ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
    } else {
      toReturn += ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
    }

    toReturn += '<img src="' +
      product.productImage + '" onerror="this.onerror=null;this.src=\'' +
      klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/></a></div>';
    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText + ' ' +
          Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';
      }
    }


    prodPrice = typeof product.price !== 'undefined' && product.price ? Number(product.price) : "";
    prodSalePrice = typeof product.salePrice !== 'undefined' && product.salePrice ? Number(product.salePrice) : "";
    prodOldPrice = typeof product.oldPrice !== 'undefined' && product.oldPrice ? Number(product.oldPrice) : "";


    // show discount percentage:
    function discountPercentage(aVal, bVal) {
      var diff = bVal - aVal;
      var discountPercentage = Math.round(100 * diff / bVal);
      if (discountPercentage > 0) {
        toReturn += '<span class="productitem--badge badge--sale" data-badge-sales="">Save <span data-price-percent-saved="' + discountPercentage + '">' + discountPercentage + '</span>%</span>';
      }
    }

    if ((prodSalePrice) < (prodPrice)) {
      discountPercentage(prodSalePrice, prodPrice);
    }
    if ((prodSalePrice) < (prodOldPrice)) {
      discountPercentage(prodSalePrice, prodOldPrice);
    }


    toReturn += '<div class="kuNameDesc">';
    toReturn += '<div class="kuName"><a href="' + product.productUrl.replace(/"/g, "%22") +
      '" target="_blank" ';
    if (klevu_commons.isMobileDevice()) {
      toReturn += ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
    } else {
      toReturn += ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
    }
    toReturn += product.productName + '</a></div>';
    toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      toReturn += '<div class="kuStarsSmall">' +
        '<div class="kuRating" style="width:' + starWidth +
        '%;"></div></div>';
    }
    toReturn += '</div>';

    toReturn += '<div class="kuPrice">';
    if (klevu_showPrices) {
      if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
        toReturn += klevu_commons.showOriginalAndSalePrices('LANDING', product,
          salepriceClass, 'kuSalePrice kuSpecialPrice');
      } else {
        toReturn += klevu_commons.showProductPrices('LANDING', product,
          salepriceClass, 'kuSalePrice kuSpecialPrice');
      }

    }

    if (klevu_userOptions.vatCaption.trim().length > 0) {
      toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
    }

    if (product.totalProductVariants && product.totalProductVariants != '0') {
      if (klevu_uiLabels.variants.indexOf("#") === -1) {
        toReturn += '<div class="klevu-variants">+' + product.totalProductVariants +
          ' ' + klevu_uiLabels.variants + '</div>';
      } else {
        toReturn += '<div class="klevu-variants">' +
          klevu_uiLabels.variants.replace("#", product.totalProductVariants) + '</div>';
      }
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if ((product.inStock) && product.inStock === 'no') {
        toReturn += '<div class="klevu-out-of-stock">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }

    toReturn += '</div>';
    if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
      if (!product.totalProductVariants || product.totalProductVariants == '0') {
        if (product.defaultQty) {
          addToCartQty = +(product.defaultQty);
        }
        toReturn += '<div class="kuAddtocart">' +
          '<input type="text" name="klevu-qty" id="klevu-qty-' +
          escape(product.productCode) + '" placeholder="' +
          klevu_uiLabels.addToCartPlaceholder + '" value="' + addToCartQty + '"/>' +
          '<a href="javascript:klevu_lpSendProductToCart(\'' +
          escape(product.productCode) + '\', \'' +
          escape(product.productUrl) + '\', \'klevu-qty-' +
          escape(product.productCode) + '\');" ' +
          'class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
          '</div>';
      } else {
        toReturn += '<div class="kuAddtocart">' +
          '<a href="' + product.productUrl.replace(/"/g, "%22") +
          '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
          '</div>';
      }
      toReturn += '<div class="klevu-clearboth-listview"></div>';
    }
    toReturn += '<div class="kuClearLeft"></div>';
    toReturn += '</li>';

    return toReturn;
  }
}